export const ARTDECO_MODAL_OUTLET = '#artdeco-modal-outlet';